import LiveBadge from "../common/LiveBadge";
import { useLiveInfo } from "../common/LiveInfoProvider";

export default function TournamentLiveBadge(props) {
    const liveInfo = useLiveInfo();

    if (liveInfo?.liveTournaments.has(props.uniqueId)) {
        return <LiveBadge className="inline-flex ml-2" />;
    }

    return null;
}
